var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.context.advisor_id)?_c('ClientPreferences',{attrs:{"context":_vm.context,"prospect":_vm.prospect,"vadisNonEmbed":_vm.vadisNonEmbed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }